<template>
  <router-view />
</template>

<script>
  export default {
    name: 'MaterialIndex'
  }
</script>
